
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkItemAvailableFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NamespaceAvailableFeatures"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasIssueWeightsFeature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasIterationsFeature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasOkrsFeature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasSubepicsFeature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasIssuableHealthStatusFeature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasEpicsFeature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasScopedLabelsFeature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasQualityManagementFeature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasLinkedItemsEpicsFeature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasIssueDateFilterFeature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasBlockedIssuesFeature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasGroupBulkEditFeature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasCustomFieldsFeature"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkItemLinkPaths"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NamespacesLinkPaths"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuesList"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contributionGuidePath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"labelsManage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newProject"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"register"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reportAbuse"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"signIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userExportEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emailsHelpPagePath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"markdownHelpPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"quickActionsHelpPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calendarPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rssPath"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectNamespaceLinks"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newWorkItemEmailAddress"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":720}};
    doc.loc.source = {"body":"fragment WorkItemAvailableFeatures on NamespaceAvailableFeatures {\n  hasIssueWeightsFeature\n  hasIterationsFeature\n  hasOkrsFeature\n  hasSubepicsFeature\n  hasIssuableHealthStatusFeature\n  hasEpicsFeature\n  hasScopedLabelsFeature\n  hasQualityManagementFeature\n  hasLinkedItemsEpicsFeature\n  hasIssueDateFilterFeature\n  hasBlockedIssuesFeature\n  hasGroupBulkEditFeature\n  hasCustomFieldsFeature\n}\n\nfragment WorkItemLinkPaths on NamespacesLinkPaths {\n  issuesList\n  contributionGuidePath\n  labelsManage\n  newProject\n  register\n  reportAbuse\n  signIn\n  userExportEmail\n  emailsHelpPagePath\n  markdownHelpPath\n  quickActionsHelpPath\n  calendarPath\n  rssPath\n  ... on ProjectNamespaceLinks {\n    newWorkItemEmailAddress\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["WorkItemAvailableFeatures"] = oneQuery(doc, "WorkItemAvailableFeatures");
        
        module.exports["WorkItemLinkPaths"] = oneQuery(doc, "WorkItemLinkPaths");
        
